import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { LmsService } from "../services/lms.service";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";

@Component({
    selector: "app-lms-waiver-list",
    templateUrl: "./lms-waiver-list.component.html",
    styleUrls: ["./lms-waiver-list.component.scss"],
    standalone: false
})
export class LmsWaiverListComponent implements OnInit {
  showSpinner: boolean = false;
  dataSource: any;
  status: any = "Pending";
  currentUser: any;
  Data: any[] = [];
  JsonData: any[] = [];
  displayedColumns: string[] = [
    "Waivar_Id",
    "ApplicationNo",
    "LoanAcNo",
    "Customer",
    "Branch",
    "Product",
    "Loan_Date",
    "Amount",
    "Creation_Remark",
    "CreateOn",
    "AuthorizBy",
    "AuthorizRemark",
    "AuthorizOn",
    "Status",
    "Action",
  ];
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private dataSharingService: DataSharingService,
    private lmsService: LmsService
  ) {}

  ngOnInit(): void {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.dataSharingService.HeaderTitle.next("Waiver List");
    this.Get_Waiver_List_By_Status();
  }

  Get_Waiver_List_By_Status() {
    if (this.status == "Pending") {
      this.displayedColumns = [
        "Waivar_Id",
        "ApplicationNo",
        "LoanAcNo",
        "Customer",
        "Branch",
        "Product",
        "Loan_Date",
        "Request_Total_Amount",
        "CreateOn",
        "Creation_Remark",
        "AuthorizBy",
        "Status",
        "Action",
      ];
    } else if (this.status == "Approved") {
      this.displayedColumns = [
        "Waivar_Id",
        "ApplicationNo",
        "LoanAcNo",
        "Customer",
        "Branch",
        "Product",
        "Loan_Date",
        "Request_Total_Amount",
        "Approved_Total_Amount",
        "Creation_Remark",
        "CreateOn",
        "AuthorizBy",
        "AuthorizOn",
        "AuthorizRemark",
        "Status",
        "Action",
      ];
    } else {
      this.displayedColumns = [
        "Waivar_Id",
        "ApplicationNo",
        "LoanAcNo",
        "Customer",
        "Branch",
        "Product",
        "Loan_Date",
        "Request_Total_Amount",
        "Creation_Remark",
        "CreateOn",
        "RejectedBy",
        "RejectedOn",
        "RejectedRemark",
        "Status",
        "Action",
      ];
    }

    this.lmsService
      .Get_Waiver_List_By_Status({
        LoginUserId: this.currentUser.userId,
        Status: this.status,
        Type: "Created",
      })
      .subscribe((res: any) => {
        console.log("data", res);
        this.Data = JSON.parse(JSON.stringify(res));
        console.log("DATA", this.Data);

        this.dataSource = new MatTableDataSource(res);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.showSpinner = false;
      });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  goToSaveDetail(row) {}

  // exportTable(): void {
  //   const uri = "data:application/vnd.ms-excel;base64,";
  //   const template =
  //     '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
  //   const base64 = (s: string): string =>
  //     window.btoa(unescape(encodeURIComponent(s)));
  //   const format = (s: string, c: { [key: string]: string }): string =>
  //     s.replace(/{(\w+)}/g, (m, p) => c[p]);

  //   const table = document.getElementById(
  //     "legal_assign_cases"
  //   ) as HTMLTableElement;
  //   const worksheetName = "LEGAL ASSIGN CASES"; // Set the desired worksheet name here
  //   const ctx = { worksheet: worksheetName, table: table.innerHTML };
  //   const downloadLink = document.createElement("a");

  //   // Generate the data URI for the Excel file
  //   downloadLink.href = uri + base64(format(template, ctx));

  //   // Set the file name for the download
  //   downloadLink.download = worksheetName + ".xls";

  //   // Trigger the download
  //   downloadLink.click();
  // }

  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: "WAIVER LIST",
      sheet: "WAIVER LIST",
    });
  }

  GetData(data) {
    if (data == true) {
      this.Get_Waiver_List_By_Status();
    }
  }
}
